import { CountryType } from "@letshang/assets"
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber"

const phoneUtil = PhoneNumberUtil.getInstance()

export const getFormattedPhone = (
  digits: number | string,
  country: CountryType,
) => {
  try {
    const inputNumber = String(digits || "").replace(/[^\d+]/g, "")
    if (!inputNumber) {
      console.error("Input number is empty or invalid")
      return
    }
    // Validate the country code
    if (!country || !country.code) {
      console.error("Country code is missing or invalid")
      return
    }

    if (inputNumber.length < 2) {
      return inputNumber
    }
    // Parse the number
    const parsedNumber = phoneUtil.parse(inputNumber, country.code)

    // Format the number in NATIONAL format
    let formattedDisplay = phoneUtil.format(
      parsedNumber,
      PhoneNumberFormat.NATIONAL,
    )

    // Remove leading '0' if present
    if (formattedDisplay.startsWith("0")) {
      formattedDisplay = formattedDisplay.replace(/^0/, "")
    }

    return formattedDisplay
  } catch (error) {
    console.error("Error formatting phone number:", JSON.stringify(error))
    // setPhoneDisplayed("Invalid phone number");
  }
}
